import React from "react";

const SubscriptionsLoader = () => {
    return(
        Array.from({ length: 4 }).map((_, index) => (
          <div key={index} className="subscription_loader fade-in" />
        ))
    )
}

export default SubscriptionsLoader